import 'react-datepicker/dist/react-datepicker.css'

import { Box, Text } from '@chakra-ui/react'
import { ClassNames } from '@emotion/react'
import _ from 'lodash'
import { DateTime } from 'luxon'
import ReactDatePicker from 'react-datepicker'

import { useCurrentUser } from 'src/lib/hooks/auth/useCurrentUser'
import useField from 'src/lib/hooks/form/useField'
import { getColorHexValue } from 'src/lib/utils'

import DatePickerHeader from './DatePickerHeader/DatePickerHeader'
import DatePickerInput from './DatePickerInput/DatePickerInput'
import { dynamicStyle } from './dynamicStyle'

const renderDayContents = (day: number, _date: Date) => {
  return <Text color="onyx">{day}</Text>
}

const DatePicker: React.FC<{
  name: string
  placeholder: string
  flex?: number
  endOfDay?: boolean
}> = ({ name, placeholder, flex, endOfDay }) => {
  const [open, setOpen] = React.useState<boolean>(false)

  const field = useField<string>(name)

  const { brandColor } = useCurrentUser()

  const colorHex = getColorHexValue(brandColor) as string

  const selected = DateTime.fromISO(field?.value).isValid
    ? DateTime.fromISO(field?.value).toJSDate()
    : undefined

  return (
    <Box position="relative" flex={flex}>
      <ClassNames>
        {({ css, cx }) => (
          <ReactDatePicker
            onChange={(jsDate) => {
              let date = DateTime.fromJSDate(jsDate)
              if (endOfDay) {
                date = date.startOf('day').plus({ day: 1 }).minus({ minute: 1 })
              }
              field?.onChange(date.toISO())
              setOpen(false)
            }}
            selected={selected}
            calendarStartDay={1}
            onCalendarClose={() => setOpen(false)}
            onCalendarOpen={() => {
              setOpen(true)
            }}
            onClickOutside={() => {
              setOpen(false)
            }}
            open={open}
            formatWeekDay={(day) => {
              return day.substring(0, 3)
            }}
            renderCustomHeader={(props) => <DatePickerHeader {...props} />}
            renderDayContents={renderDayContents}
            calendarClassName={cx(css(dynamicStyle(colorHex)))}
            popperProps={{ strategy: 'fixed' }}
            customInput={<></>}
          />
        )}
      </ClassNames>
      <DatePickerInput
        setOpen={setOpen}
        title={placeholder}
        active={open}
        w="100%"
        date={selected}
        onClearDate={() => {
          field?.onChange(null)
          setOpen(false)
        }}
      />
    </Box>
  )
}

export default DatePicker
